enum Status {
  Success = 'success',
  Danger = 'danger',
  Warn = 'warn',
  Neutral = 'neutral',
  Busy = 'busy',
}

export default Status
